const ferries = {
  ferry: "나룻배", // translated 
  ferries: "페리", // translated 
  selectOriginPort: "출발 항구를 선택하세요", // translated 
  selectDestPort: "목적지 항구를 선택하세요", // translated 
  continue: "계속하다", // translated 
  viewTimetables: "시간표 보기", // translated 
  operator: "연산자", // translated 
  cabin: "선실", // translated 
  cabins: "오두막", // translated 
  place: "장소", // translated 
  places: "장소", // translated 
  seat: "좌석", // translated 
  seats: "좌석", // translated 
  seating: "좌석", // translated 
  deckSpace: "데크 공간", // translated 
  compulsory: "의무적인", // translated 
  departure: "출발", // translated 
  total: "총", // translated 
  back: "뒤쪽에", // translated 
  next: "다음", // translated 
  duration: "지속", // translated 
  return: "반품", // translated 
  prebook: "사전 예약", // translated 
  travelInfo: "여행 정보", // translated 
  book: "책", // translated 
  adults: "성인", // translated 
  child: "어린이", // translated 
  seniors: "어른", // translated 
  senior: "상위", // translated 
  to: "에게", // translated 
  passenger: "승객", // translated 
  details: "세부", // translated 
  currencyForTickets: "이 티켓의 사용 통화는 다음과 같습니다.", // translated 
  seatsError: "승객 수가 수용 능력과 일치하지 않습니다.", // translated 
  title: "제목", // translated 
  firstName: "이름", // translated 
  lastName: "성", // translated 
  email: "이메일", // translated 
  phone: "핸드폰", // translated 
  dateOfBirth: "생일", // translated 
  placeOfBirth: "출생지", // translated 
  groupLeader: "그룹 리더", // translated 
  isRequired: "필수입니다", // translated 
  charactersOnly: "문자만", // translated 
  latinCharactersAndSpacesOnly: "라틴 문자 및 공백만 사용 가능", // translated 
  validEmail: "유효하지 않은 이메일입니다.", // translated 
  atLeastOneAdult: "성인 최소 1명이 필요합니다.", // translated 
  atLeastOneSenior: "최소 1명의 고학년 학생이 필요합니다.", // translated 
  toastAlert: "아래 양식의 모든 오류를 수정해 주십시오.", // translated 
  backToFerriesList: "페리 목록으로 돌아가기", // translated 
  bestPrice: "최저가", // translated 
  fastest: "가장 빠른", // translated 
  beforeDeparture: "출발 전", // translated 
  perPerson: "1인당", // translated 
  notAvailableForOnlineBooking: "온라인 예약이 불가능합니다.", // translated 
  hurryLimitedAvailability: "서두르세요! 수량이 한정되어 있습니다.", // translated 
  berth: "침대", // translated 
  berths: "선석", // translated 
  sumOfSelectionNotEqualToPersons:
    "선택하신 항목의 합계가 승객 수와 일치하지 않습니다.", // translated 
  attemptToBook: "총 예약 시도 횟수:", // translated 
  seatsWhenYouHave: "좌석이 있을 때", // translated 
  passengersTravelling: "승객들이 여행하는", // translated 
  withReturn: "왕복 티켓 포함", // translated 
  pleaseCorrectYourSelection: "선택 사항을 수정해 주세요.", // translated 
  pleaseSelectUpTo: "최대값을 선택해 주세요.", // translated 
  accommodationTypes: "숙박 유형", // translated 
  selectionPrices: "선택 가격", // translated 
  yourCurrentTicket: "현재 티켓 유형은 다음과 같습니다.", // translated 
  upgradeTo: "업그레이드하세요", // translated 
  wouldYouLikeToUpgrade: "티켓 종류를 업그레이드하시겠습니까?", // translated 
  backToTicketTypes: "티켓 종류로 돌아가기", // translated 
  originPort: "출발항", // translated 
  destinationPort: "목적지 항구", // translated 
  outboundDate: "출발일", // translated 
  inboundDate: "수신 날짜", // translated 
  passengers: "승객들", // translated 
  hasReturn: "돌아왔습니다", // translated 
  passportNumber: "여권 번호", // translated 
  passportExpiryDate: "여권 만료일", // translated 
  passportPlaceOfIssue: "여권 발급 장소", // translated 
  passportStartDate: "여권 시작일", // translated 
  cityCode: "도시 조례", // translated 
};


export default ferries;
